import { createSlice } from '@reduxjs/toolkit';
import { clearPlantItemRenewalForm } from 'plantItemNew/redux/slices/formSlice';
import { getApplication } from 'shared/redux/applicationSlice';

const initialState = {
  stamp: null,
  accepted: false,
};

const plantItemRenewalDeclarationSlice = createSlice({
  name: 'plantItemRenewalDeclaration',
  initialState,
  reducers: {
    storePlantItemRenewalDeclaration(state, action) {
      state.accepted = true;
      state.stamp = action.payload.stamp;
    },
    clearPlantItemRenewalDeclaration(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearPlantItemRenewalForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.plantItemRenewalDeclaration };
      });
  },
});

export const { storePlantItemRenewalDeclaration, clearPlantItemRenewalDeclaration } =
  plantItemRenewalDeclarationSlice.actions;
export const plantItemRenewalDeclarationReducer = plantItemRenewalDeclarationSlice.reducer;
